module.exports = __webpack_public_path__ + "img/C07TechRaiderChampion_ua.f10a2c9b.webp";